(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ksc-content-protection"] && !Shopify.designMode) return;
  try {
    const protectionRoot = document.querySelector('[data-ksc-content-protection]');

  if (protectionRoot && protectionRoot.dataset.initialized !== 'true') {
    protectionRoot.dataset.initialized = 'true';

    const protectText = protectionRoot.dataset.protectText === 'true';
    const isEditable = (target) =>
      target instanceof Element &&
      Boolean(target.closest('input, textarea, select, [contenteditable="true"]'));

    document.addEventListener('contextmenu', (event) => {
      if (!isEditable(event.target)) {
        event.preventDefault();
      }
    });

    document.addEventListener('dragstart', (event) => {
      if (event.target instanceof Element && event.target.closest('img, picture, svg')) {
        event.preventDefault();
      }
    });

    if (protectText) {
      document.addEventListener('copy', (event) => {
        if (!isEditable(event.target)) {
          event.preventDefault();
        }
      });

      document.addEventListener('cut', (event) => {
        if (!isEditable(event.target)) {
          event.preventDefault();
        }
      });
    }

    document.addEventListener('keydown', (event) => {
      if (isEditable(event.target)) {
        return;
      }

      const key = event.key.toLowerCase();
      const standardShortcut = (event.ctrlKey || event.metaKey) && (key === 's' || key === 'u');
      const macSourceShortcut = event.metaKey && event.altKey && key === 'u';

      if (standardShortcut || macSourceShortcut) {
        event.preventDefault();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
